import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$stock, _vm$stock2, _vm$stock3, _vm$stock4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Split stock")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_c("div", {
    staticClass: "text-smaller"
  }, [_c("div", [_vm._v(_vm._s("".concat((_vm$stock = _vm.stock) === null || _vm$stock === void 0 ? void 0 : _vm$stock.quantity, " x ").concat((_vm$stock2 = _vm.stock) === null || _vm$stock2 === void 0 || (_vm$stock2 = _vm$stock2.wine) === null || _vm$stock2 === void 0 ? void 0 : _vm$stock2.display_name)))])]), _c(VForm, {
    staticClass: "dfwa-form mt-default",
    model: {
      value: _vm.addingEntity.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "valid", $$v);
      },
      expression: "addingEntity.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      type: "number",
      label: "Quantity to split",
      placeholder: "Number of bottles",
      min: 1,
      max: (_vm$stock3 = _vm.stock) === null || _vm$stock3 === void 0 ? void 0 : _vm$stock3.quantity,
      rules: [_vm.formRules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingEntity.form.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "quantity", $$v);
      },
      expression: "addingEntity.form.quantity"
    }
  }), _c(VSelect, {
    staticClass: "required",
    attrs: {
      chips: "",
      items: _vm.countries,
      label: "Intended countries",
      "item-text": "printable_name",
      "item-value": "id_country",
      placeholder: "France",
      multiple: "",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      "data-cy": "stock-intended-countrie-input"
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function fn() {
        return [_c(VListItem, {
          attrs: {
            ripple: "",
            "data-cy": "stock-intended-countrie-select-all-btn"
          },
          on: {
            click: _vm.changeIntendedCountries
          }
        }, [_c(VListItemAction, [_c(VIcon, [_vm._v(" " + _vm._s(_vm.getIconForIntendedCountriesCloser) + " ")])], 1), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("Select All")])], 1)], 1), _c(VDivider, {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.addingEntity.form.countryIds,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "countryIds", $$v);
      },
      expression: "addingEntity.form.countryIds"
    }
  }), _c("StockReservation", {
    ref: "reservation",
    attrs: {
      form: {
        stockReservationType: _vm.addingEntity.form.reservationType,
        stockReservationUserId: _vm.addingEntity.form.reservationUserId,
        stockReservationConsultantId: _vm.addingEntity.form.reservationConsultantId
      },
      isPrefixedWithDefault: false,
      reservedForMessage: ((_vm$stock4 = _vm.stock) === null || _vm$stock4 === void 0 ? void 0 : _vm$stock4.stock_type.toLowerCase()) === "stock" && (!!_vm.addingEntity.form.reservationUserId || !!_vm.addingEntity.form.reservationConsultantId) ? "Please be cautious that the intended countries are compatibles with this reservation" : ""
    },
    on: {
      change: _vm.updateStockReservation,
      mounted: _vm.firstMountStockReservation
    }
  }), _c("div", {
    staticClass: "mt-3"
  }, [_c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v(" Low stock data will be handled only if a new stock is created ")]), _c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      label: "Has low stock alert",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.hasLowStockAlert,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "hasLowStockAlert", $$v);
      },
      expression: "addingEntity.form.hasLowStockAlert"
    }
  }), _vm.addingEntity.form.hasLowStockAlert ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      type: "text",
      prefix: "Trigger alert* :",
      placeholder: "Number of bottles (60)",
      rules: [_vm.formRules.mustBeIntNotNegative],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingEntity.form.lowStockAlertQuantity,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "lowStockAlertQuantity", $$v);
      },
      expression: "addingEntity.form.lowStockAlertQuantity"
    }
  }) : _vm._e()], 1), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Comment",
      placeholder: "Explain the reason of this split",
      rules: [_vm.formRules.mustNotBeEmpty],
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "comment", $$v);
      },
      expression: "addingEntity.form.comment"
    }
  })], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.isValid,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmSplitStock();
      }
    }
  }, [_vm._v(" Split ")])], 1)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };